import { createSuitMixin as t } from "../mixins/suit.js";
import { createWidgetMixin as i } from "../mixins/widget.js";
import { connectRatingMenu as e } from "instantsearch.js/es/connectors/index.js";
import { createPanelConsumerMixin as n } from "../mixins/panel.js";
export default {
  name: "AisRatingMenu",
  mixins: [t({
    name: "RatingMenu"
  }), i({
    connector: e
  }, {
    $$widgetType: "ais.ratingMenu"
  }), n()],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    max: {
      type: Number,
      default: void 0
    }
  },
  computed: {
    widgetParams: function widgetParams() {
      return {
        attribute: this.attribute,
        max: this.max
      };
    }
  }
};